import { useCallback, useState } from "react";

// The "View PCRS details" dialog.
export const usePcrsDetails = () => {
  const [isPcrsDetailsDialogOpen, setIsPcrsDetailsDialogOpen] = useState(false);

  const openPcrsDetails = useCallback(
    () => setIsPcrsDetailsDialogOpen(true),
    []
  );
  const closePcrsDetails = useCallback(
    () => setIsPcrsDetailsDialogOpen(false),
    []
  );

  return { isPcrsDetailsDialogOpen, openPcrsDetails, closePcrsDetails };
};
